const revoData = {
  slug: "revo",
  name: "Honda Revo",

  hero: {
    shortDescription:
      "Motor bebek irit dan tangguh untuk penggunaan harian dengan mesin 110cc PGM-FI",

    variants: [
      {
        key: "revo-x-black",
        label: "Revo X",
        fullName: "Honda Revo X Quantum Black",
        startPrice: 20109000,
      },
      {
        key: "revo-x-red",
        label: "Revo X",
        fullName: "Honda Revo X Attractive Red",
        startPrice: 20109000,
      },
      {
        key: "revo-fit-red",
        label: "Revo Fit",
        fullName: "Honda Revo Fit Raving Red",
        startPrice: 18179000,
      },
    ],

    slides: [
      {
        variantKey: "revo-x-black",
        image: "/assets/motor/produk/revo/Revoquantum-black.webp",
        specs: {
          engine: "109,17 cc",
          transmission: "Manual 4 Percepatan",
          fuelInjection: "PGM-FI",
        },
      },
      {
        variantKey: "revo-x-red",
        image: "/assets/motor/produk/revo/Revoattractive-red.webp",
        specs: {
          engine: "109,17 cc",
          transmission: "Manual 4 Percepatan",
          fuelInjection: "PGM-FI",
        },
      },
      {
        variantKey: "revo-fit-red",
        image: "/assets/motor/produk/revo/Revoraving-red.webp",
        specs: {
          engine: "109,17 cc",
          transmission: "Manual 4 Percepatan",
          fuelInjection: "PGM-FI",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Revo merupakan motor bebek legendaris Honda yang dikenal irit, tangguh, dan mudah perawatannya.",
      },
      {
        type: "paragraph",
        text:
          "Menggunakan mesin 110cc berteknologi PGM-FI, Honda Revo menawarkan efisiensi bahan bakar tinggi untuk kebutuhan mobilitas harian.",
      },
      {
        type: "heading",
        text: "Desain Simpel dan Fungsional",
      },
      {
        type: "paragraph",
        text:
          "Desain ramping dan ergonomis membuat Honda Revo nyaman digunakan di berbagai kondisi jalan.",
      },
      {
        type: "heading",
        text: "Irit dan Andal",
      },
      {
        type: "paragraph",
        text:
          "Mesin SOHC Honda Revo terkenal bandel dan cocok untuk pemakaian jangka panjang.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, SOHC, Silinder Tunggal"],
      ["Kapasitas Mesin", "109,17 cc"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "6,56 kW / 7.500 rpm"],
      ["Torsi Maksimum", "8,76 Nm / 6.000 rpm"],
      ["Transmisi", "Manual, 4 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Backbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun dengan Peredam Kejut Tunggal"],
      ["Rem Depan", "Cakram (Revo X) / Tromol (Revo Fit)"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.919 x 709 x 1.080 mm"],
      ["Jarak Sumbu Roda", "1.227 mm"],
      ["Tinggi Jok", "761 mm"],
      ["Berat", "97 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,0 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Lampu Depan", "Halogen"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Revo",
    items: [
      {
        title: "Mesin 110cc PGM-FI",
        desc:
          "Teknologi injeksi Honda yang irit dan ramah lingkungan.",
      },
      {
        title: "Desain Ramping",
        desc:
          "Mudah dikendalikan dan nyaman untuk penggunaan harian.",
      },
      {
        title: "Rangka Kuat",
        desc:
          "Memberikan kestabilan dan daya tahan jangka panjang.",
      },
      {
        title: "Konsumsi BBM Irit",
        desc:
          "Salah satu motor bebek paling efisien di kelasnya.",
      },
      {
        title: "Perawatan Mudah",
        desc:
          "Biaya servis terjangkau dan suku cadang melimpah.",
      },
    ],
  },
};

export default revoData;
